<template>
  <div class="footer">
    <p>
      <span>©</span>
      <a :href="email">Veronica Solomon</a>
      <span> - {{year}}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'foot',
  computed: {
    email () {
      return `mailto:${this.$store.getters.email}`;
    },
    year () {
      return (new Date()).getFullYear();
    }
  }
}
</script>

<style lang="scss">
.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  height: 80px;

  p {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Foot.vue?c03918c2